if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          progressBar: this.querySelector('[id^="scroll-progress"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        // 初始化滚动进度条
        this.initScrollProgress();
        
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, options = {}) {
        const { scroll = true } = options;
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.updateActiveMediaState(activeMedia);
        this.prependMediaIfNeeded(activeMedia, mediaId, prepend);
        if (scroll) this.smoothScrollToMedia(activeMedia);
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      updateActiveMediaState(activeMedia) {
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
      }

      prependMediaIfNeeded(activeMedia, mediaId, prepend) {
        if (!prepend) return;
        const mediaList = activeMedia.parentElement;
        if (mediaList.firstChild !== activeMedia) mediaList.prepend(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail?.parentElement?.firstChild !== activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }

        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      smoothScrollToMedia(activeMedia) {
        this.preventStickyHeader();
        this.scrollGalleryContainer(activeMedia);
        this.scrollPageToMedia(activeMedia);
      }

      scrollGalleryContainer(activeMedia) {
        const mediaList = activeMedia.parentElement;
        if (!mediaList) return;
        mediaList.scrollTo({
          left: activeMedia.offsetLeft,
          top: activeMedia.offsetTop,
          behavior: 'smooth',
        });
      }

      scrollPageToMedia(activeMedia) {
        const activeMediaRect = activeMedia.getBoundingClientRect();
        const stickyHeaderOffset = this.getStickyHeaderOffset();
        const topBoundary = stickyHeaderOffset + 8;
        const imageAboveViewport = activeMediaRect.top < topBoundary;
        const imageBelowViewport = activeMediaRect.bottom > window.innerHeight;
        if (!imageAboveViewport && !imageBelowViewport) return;

        const viewportTargetTop = Math.max(activeMediaRect.top + window.scrollY - topBoundary, 0);
        window.scrollTo({ top: viewportTargetTop, behavior: 'smooth' });
      }

      getStickyHeaderOffset() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return 0;
        const stickyHeaderRect = this.stickyHeader.getBoundingClientRect();
        return Math.max(stickyHeaderRect.height, 0);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      initScrollProgress() {
        const gallerySlider = this.elements.viewer.querySelector('[id*="Slider-Gallery"]');
        if (!gallerySlider) return;
        
        // 延迟查找进度条元素，确保DOM完全加载
        setTimeout(() => {
          this.elements.progressBar = this.querySelector('[id^="scroll-progress"]');
          
          if (!this.elements.progressBar) {
            console.warn('Progress bar element not found');
            return;
          }
          
          // 监听滚动事件（使用防抖优化性能）
          gallerySlider.addEventListener('scroll', debounce(() => {
            this.updateScrollProgress(gallerySlider);
          }, 16)); // 60fps
          
          // 初始化进度条
          this.updateScrollProgress(gallerySlider);
          
          // 监听窗口大小变化
          this.mql.addEventListener('change', (e) => {
            if (e.matches) {
              // 桌面端，隐藏进度条
              if (this.elements.progressBar && this.elements.progressBar.parentElement) {
                this.elements.progressBar.parentElement.style.display = 'none';
              }
            } else {
              // 移动端，显示进度条
              if (this.elements.progressBar && this.elements.progressBar.parentElement) {
                this.elements.progressBar.parentElement.style.display = 'block';
                this.updateScrollProgress(gallerySlider);
              }
            }
          });
          
          // 初始状态设置
          if (!this.mql.matches && this.elements.progressBar.parentElement) {
            this.elements.progressBar.parentElement.style.display = 'block';
          }
        }, 200);
      }

      updateScrollProgress(gallerySlider) {
        if (!this.elements.progressBar || this.mql.matches) return;
        
        const scrollLeft = gallerySlider.scrollLeft;
        const scrollWidth = gallerySlider.scrollWidth;
        const clientWidth = gallerySlider.clientWidth;
        
        // 计算滚动进度百分比
        const maxScroll = scrollWidth - clientWidth;
        let scrollProgress = 0;
        
        if (maxScroll > 0) {
          scrollProgress = (scrollLeft / maxScroll) * 100;
        } else {
          // 如果没有滚动空间，显示完整进度条
          scrollProgress = 100;
        }
        
        // 确保进度条至少有一点显示（最小5%）
        const finalProgress = Math.min(100, Math.max(5, scrollProgress));
        
        // 更新进度条宽度
        this.elements.progressBar.style.width = `${finalProgress}%`;
        
        // 调试信息（可以在开发者工具中看到）
        console.log('Scroll progress:', finalProgress, 'scrollLeft:', scrollLeft, 'maxScroll:', maxScroll);
      }
    }
  );
}
